import {
  PrintBarcodeApiResponse,
  TreeNodeDTO,
  TreeNodeExtenededResponseMessageDTO,
} from 'business/models/Models';
import {
  SearchBarProvider,
  useSearchBarContext,
} from './tree/SearchBar/Context/SearchBarContext';
import { ESearchBarStatus } from './tree/SearchBar/Context/types';
import TreeDataSupplier from 'business/tree/TreeDataSupplier';
import TreeControlHeader from 'components/customComponents/TreeControl/TreeControlHeader/TreeControlHeader';
import ETreeActionTypes from 'enums/ETreeActionTypes';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import EViewType, { EViewTypeDisplayNames } from 'enums/EViewType';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { IStyle } from 'Styles';
import MainHeader from './tree/MainHeader';
import TileView from './tree/TileView';
import TreeContext from './tree/TreeContext';
import Explorer, { TreeControlDefaultState, TreeControlState } from 'components/explorer';
import ProjectSidePanel from 'components/sidePanel/projectSidePanel/projectSidePanel';
import ETreeGroupTypes from 'enums/ETreeGroupTypes';
import ETreeSortTypes from 'enums/ETreeSortTypes';
import {
  getNewFolderType,
  launchExpPrintBarCodeRequest,
  launchPlatePrintBarCodeRequest,
  openNode,
  showAlertSnackBar,
  showSnackBar,
} from 'utils/Global';
import { getExplorerPlateSelection } from 'utils/explorerPlateSelection';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

import LicenseService from 'business/services/LicenseService';
import { setProductEdition } from 'redux/reducers/experimentReducer';
import { ModalDetails } from 'business/models/CustomModels';
import { RMModal, LoadingModal } from 'components/modal';
import {
  useCheckNodeAvailability,
  usePasteNodesHandler,
} from 'components/explorer/hooks';
import useRMLite from 'CustomHooks/useRMLite';
import { DragContextProvider } from 'components/DraggableContainer/DragContextProvider';
import { RecycleBin } from '../explorer/RecycleBin';
import { useNavigate, useParams } from 'react-router';
import DragSelectionBox from '../DraggableContainer/DragSelectionBox';
import ImageNow from 'components/commandpanel/ImageNow/ImageNow';
import { useExplorerKeyboardHandler } from 'keyboardShortcuts/explorerHooks';
import useTreeControlFlags from 'components/customComponents/TreeControl/hooks';
import { useShowLabelPrinterError } from 'CustomHooks';
import { ExplorerFocusArea } from 'constants/';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import useBroadcast, { CHANNEL_ACTIONS, CHANNEL_TYPES } from 'business/broadcast';
import { useSystemProperty } from '../../CustomHooks/useSystemProperty';
import { PropertyConstants } from '../../enums/PropertyConstants';
import { ExplorerSearchStatus } from './tree/SearchBar/ExplorerSearchStatus';
import { formatDatePrepared } from './tree/utils';

let openClickedState = 0;

const ProjectDashboardContent = (props) => {
  const {
    explorerStatus: status,
    explorerResults: results,
    clearSearch,
  } = useSearchBarContext();
  const explorerRef = useRef(null);
  const savedTreeStateRef = useRef<any>(null);
  const explorerBroadcastChannel = useBroadcast(CHANNEL_TYPES.EXPLORER);
  const dispatch = useRMDispatch();
  const [gSelectedNode, setgSelectedNode] = useState(null);
  const defaultView = useSystemProperty(
    PropertyConstants.DefaultExplorerView,
    EViewType.ListView,
    true,
  );

  const [treeControlState, setTreeControlState] = useState<TreeControlState>({
    ...TreeControlDefaultState,
  });

  const [commonTreeNodes, setCommonTreenodes] = useState([]);
  const [openClicked, setOpenClicked] = useState(openClickedState);
  const [activeDropDown, setActiveDropDown] = useState('');
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(true);
  const [copyNodeId, setCopyNodeId] = useState<number>(-1);
  const [operationType, setOperationType] = useState<ETreeActionTypes>(
    ETreeActionTypes.None,
  );
  const [copyNodeIdParent, setCopyNodeIdParent] = useState<number>(0);
  const [copyNodeType, setCopyNodeType] = useState<string>('');
  const [copyNodeParentId, setCopyNodeParentId] = useState<number>(-1);
  const [copyNodeName, setCopyNodeName] = useState<string>('');
  const [sameNodeCopyId, setSameNodeCopyId] = useState<number>(-1);
  const [currentOperation, setCurrentOperation] = useState<string>('In Progress');
  const [showCommandPanel, setShowCommandPanel] = useState<boolean>(false);
  const [{ viewType, isViewTypeSetByUser }, setViewTypeState] = useState<{
    viewType: EViewType;
    isViewTypeSetByUser: boolean;
  }>({ viewType: EViewType.ListView, isViewTypeSetByUser: false });
  const setViewType = useCallback(
    (view: EViewType) => setViewTypeState({ viewType: view, isViewTypeSetByUser: true }),
    [],
  );
  const [groupBy, setGroupBy] = useState<ETreeGroupTypes>(ETreeGroupTypes.Type);
  const [sortBy, setSortBy] = useState<ETreeSortTypes>(ETreeSortTypes.Type);
  const [openedWindows, setOpenedWindows] = useState([]);
  const isLoading = false;
  const [nodesToCopy, setNodesToCopy] = useState<TreeNodeDTO[]>([]);
  const [isDragSelect, setIsDragSelect] = useState<boolean>(false);
  const [showProteinVariantModal, setShowProteinVariantModal] = useState<boolean>(false);
  const showLabelPrinterError = useShowLabelPrinterError();
  const [focusedArea, setFocusedArea] = useState<ExplorerFocusArea>(
    ExplorerFocusArea.None,
  );
  const [showSearchStatus, setShowSearchStatus] = useState<boolean>(false);

  useEffect(() => {
    if (!isViewTypeSetByUser) {
      setViewTypeState({
        viewType: EViewTypeDisplayNames[defaultView] ?? EViewType.ListView,
        isViewTypeSetByUser: false,
      });
    }
  }, [defaultView, isViewTypeSetByUser]);

  useEffect(() => {
    if (status === ESearchBarStatus.Loading || status === ESearchBarStatus.NoResults) {
      if (!savedTreeStateRef.current) {
        savedTreeStateRef.current = {
          selectedExplorerNode: treeControlState.selectedExplorerNode,
          selectedNodes: treeControlState.selectedNodes,
          viewNodes: treeControlState.viewNodes,
          breadcrumbs: treeControlState.breadcrumbs,
        };
      }
      setTreeControlState((prev) => ({
        ...prev,
        selectedExplorerNode: null,
        selectedNodes: [],
      }));
      setShowSearchStatus(true);
    } else if (status === ESearchBarStatus.Empty && savedTreeStateRef.current) {
      const saved = savedTreeStateRef.current;
      savedTreeStateRef.current = null;
      setTreeControlState((prev) => ({
        ...prev,
        viewNodes: saved.viewNodes,
        selectedNodes: saved.selectedNodes,
        breadcrumbs: saved.breadcrumbs,
        selectedExplorerNode: saved.selectedExplorerNode,
      }));
      setShowSearchStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (status === ESearchBarStatus.Finished) {
      setTreeControlState((prev) => ({
        ...prev,
        viewNodes: results.map((r) => ({
          id: r.nodeId,
          name: r.name,
          type: r.type,
          parentId: r.containerNodeId,
          datePrepared: formatDatePrepared(r.datePrepared),
          extra: {
            id: r.entityId ?? r.nodeId,
            // PlateInfoDTO uses dispensed/imaged; Detail View's date columns key off
            // dateDispensed/lastImaged (see NodeDetailView), so remap here.
            plates: r.plates?.map((p) => ({
              ...p,
              dateDispensed: p.dispensed,
              lastImaged: p.imaged,
            })),
            status: r.status,
            state: r.state,
            owner: r.owner,
          },
        })) as TreeNodeDTO[],
        selectedNodes: [],
      }));
      setShowSearchStatus(false);
    }
  }, [results, status]);

  const _setProductEdition = useCallback(
    (productEdition: string) => dispatch(setProductEdition(productEdition)),
    [dispatch],
  );
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: null,
    heading: '',
    isOkOnly: false,
    okButtonText: undefined,
    noButtonText: undefined,
    showButtons: true,
    dialogClassName: '',
    isCancelOnly: false,
  });
  const checkAvailability = useCheckNodeAvailability();
  const pasteNodesHandler = usePasteNodesHandler();
  const isRMLiteUser = useRMLite();
  const navigate = useNavigate();
  const { treeNodeId } = useParams();
  const nodesParentContainerRef = useRef<HTMLDivElement>(null);
  const isClientOnlyNodeSelected =
    treeControlState?.selectedExplorerNode?.type === ETreeNodeTypes.QuickAccess ||
    treeControlState.selectedExplorerNode?.type === ETreeNodeTypes.RecycleBin;

  const refreshExplorer = useCallback(async () => {
    await explorerRef?.current?.generateAllTreeNodesById(treeNodeId);
  }, [treeNodeId]);

  const refreshSelectedExplorerNode = useCallback(async () => {
    const selectedExplorerNode = treeControlState?.selectedExplorerNode;
    if (!selectedExplorerNode?.id) {
      return;
    }
    await explorerRef?.current?.onRefreshTreeNode(
      {
        id: selectedExplorerNode.id,
        parentId: selectedExplorerNode.parentId,
      },
      true,
    );
  }, [treeControlState?.selectedExplorerNode]);

  const selectAllNodes = () => {
    if (treeControlState?.viewNodes?.length > 0) {
      setTreeControlState((prev) => ({
        ...prev,
        selectedNodes: [...treeControlState.viewNodes],
        isContextBackground: false,
      }));
    }
  };

  const handleOnNodesDelete = useCallback(async () => {
    if (
      !isEditAllowed ||
      !canModifyNode ||
      isControlsDisabled ||
      isAnySelectedNodeLocked ||
      isClientOnlyNodeSelected
    ) {
      return;
    }
    setOperationType(ETreeActionTypes.Delete);
    await checkAvailability(
      treeControlState.selectedNodes.map((node: TreeNodeDTO) => ({
        treeNodeId: node.id,
        name: node.name,
        type: node.type as ETreeNodeTypes,
        entityId: node?.extra?.id,
        extra: node.extra,
      })),
      nodesDeletePostProcessor,
    );
  }, [treeControlState.selectedNodes, isClientOnlyNodeSelected]);

  const onDragSelectionSelect = (selectedTreeNodeIds: number[]) => {
    const selectedNodes = treeControlState.viewNodes.filter((node) =>
      selectedTreeNodeIds.includes(node.id),
    );
    setTreeControlState((prev) => ({
      ...prev,
      selectedNodes,
      isContextBackground: false,
    }));
  };

  const { isControlKeyPressed, isShiftKeyPressed } = useExplorerKeyboardHandler({
    onF5Press: refreshExplorer,
    onDeletePress: handleOnNodesDelete,
    onCtrlAPress: selectAllNodes,
    nodesParentContainerRef,
    selectedNodes: treeControlState.selectedNodes,
    selectNodesById: onDragSelectionSelect,
    rmLite: isRMLiteUser,
    focusedArea: focusedArea,
    setFocusedArea: setFocusedArea,
  });

  useEffect(() => {
    const licenseService = new LicenseService();
    const setProductLicense = async () => {
      const productEdition = await licenseService.getProductEdition();
      _setProductEdition(productEdition.edition);
    };
    setProductLicense();
  }, []);

  function changeActiveDropDown(val) {
    setActiveDropDown(val);
  }

  const OpenClickHeaderHandler = useCallback(() => {
    openClickedState = openClicked + 1;
    setOpenClicked(openClicked + 1);
  }, [openClicked]);

  const changeActiveDropDownHandler = useCallback(() => changeActiveDropDown(''), []);

  const sidePanelStyle = useMemo(
    () => (isSidePanelOpen ? {} : styles.sidePanelClose),
    [isSidePanelOpen],
  );
  const contentStyle = useMemo(
    () => (isSidePanelOpen ? styles.mainContainershrink : styles.width100),
    [isSidePanelOpen],
  );

  const getNewFolderName = useMemo(() => {
    return getNewFolderType(
      treeControlState.treenodes,
      treeControlState.selectedExplorerNode,
    );
  }, [treeControlState.treenodes, treeControlState.selectedExplorerNode]);

  const treeControlFlags = useTreeControlFlags(
    treeControlState,
    nodesToCopy,
    getNewFolderName,
  );
  const { isAnySelectedNodeLocked, isEditAllowed, canModifyNode, isControlsDisabled } =
    treeControlFlags;

  const cutNode = useCallback(() => {
    setOperationType(ETreeActionTypes.Cut);
    setNodesToCopy(treeControlState.selectedNodes);
    showSnackBar('Cut!');
  }, [treeControlState.selectedNodes]);

  const printBarcode = useCallback(async () => {
    showSnackBar('Barcode sent for printing.');
    const expIds = [
      ...new Set(
        treeControlState.selectedNodes.map((node) => node.extra?.id).filter(Boolean),
      ),
    ];
    const plateSelection = getExplorerPlateSelection();
    const hasScopedPlates =
      plateSelection.plateIds.length > 0 &&
      plateSelection.experimentId != null &&
      expIds.includes(plateSelection.experimentId);
    const wholeExperimentIds = hasScopedPlates
      ? expIds.filter((id) => id !== plateSelection.experimentId)
      : expIds;

    const printResponses: PrintBarcodeApiResponse[] = [];
    if (wholeExperimentIds.length) {
      printResponses.push(...(await launchExpPrintBarCodeRequest(wholeExperimentIds)));
    }
    if (hasScopedPlates) {
      printResponses.push(
        ...(await launchPlatePrintBarCodeRequest(plateSelection.plateIds)),
      );
    }
    if (printResponses?.some((r) => r?.value != '')) {
      showLabelPrinterError();
    } else {
      const truncMsg = printResponses?.find((r) => r.infoMessage?.trim())?.infoMessage;
      if (truncMsg) {
        showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, truncMsg);
      }
    }
  }, [treeControlState.selectedNodes]);

  const copyNode = useCallback(async () => {
    setOperationType(ETreeActionTypes.Copy);
    setNodesToCopy(treeControlState.selectedNodes);
    showSnackBar('Copied!');
  }, [treeControlState.selectedNodes]);

  const nodesDeletePostProcessor = async (
    deletedNodeIds: number[],
    undeletedNodes: TreeNodeExtenededResponseMessageDTO[],
  ) => {
    explorerRef?.current?.filterQuickAccess(deletedNodeIds);
    setOperationType(ETreeActionTypes.None);

    const deletedExplorerNode = treeControlState.selectedExplorerNode;
    const deletedIdSet = new Set(
      (deletedNodeIds ?? []).map((id) => Number(id)).filter((id) => !Number.isNaN(id)),
    );
    const isExplorerDeleted = deletedIdSet.has(Number(deletedExplorerNode?.id));
    const survivingSelectedNodes = treeControlState.selectedNodes.filter(
      (node) => !deletedIdSet.has(Number(node.id)),
    );

    if (isExplorerDeleted) {
      const parentId =
        deletedExplorerNode?.parentId ??
        deletedExplorerNode?.ParentId ??
        treeControlState.selectedNodes.find((node) => deletedIdSet.has(Number(node.id)))
          ?.parentId;
      if (parentId != null) {
        navigate(`/project/${parentId}`, { replace: true });
      }
      if (parentId != null && !deletedIdSet.has(Number(parentId))) {
        await explorerRef?.current?.onRefreshTreeNode(
          {
            id: parentId,
            parentId: deletedExplorerNode?.parentId,
          },
          true,
          null,
          null,
          true,
          [...deletedIdSet],
        );
      }
    } else {
      const deletedSelectedNodeIds = treeControlState.selectedNodes
        .filter((node) => deletedIdSet.has(Number(node.id)))
        .map((node) => node.id);
      if (
        deletedSelectedNodeIds.length &&
        !survivingSelectedNodes.length &&
        deletedExplorerNode?.id != null
      ) {
        navigate(`/project/${deletedExplorerNode.id}`, { replace: true });
      }
      const refreshId = deletedExplorerNode?.id;
      if (refreshId != null && !deletedIdSet.has(Number(refreshId))) {
        await explorerRef?.current?.onRefreshTreeNode(
          {
            id: refreshId,
            parentId: deletedExplorerNode?.parentId,
          },
          true,
          null,
          survivingSelectedNodes.length ? survivingSelectedNodes : null,
          false,
          [...deletedIdSet],
        );
      }
    }

    const folderToRefreshId = isExplorerDeleted
      ? deletedExplorerNode?.parentId ?? deletedExplorerNode?.ParentId
      : deletedExplorerNode?.id;

    explorerBroadcastChannel?.postMessage({
      action: CHANNEL_ACTIONS.EXPLORER_DELETE_NODE,
      payload: { parentId: folderToRefreshId, deletedNodeIds },
    });

    setShowCommandPanel(false);
  };

  const nodesPastePostProcessor = async () => {
    if (operationType === ETreeActionTypes.Copy) {
      const parentId = treeControlState.selectedExplorerNode?.id;
      await explorerRef.current.onRefreshTreeNode({ id: parentId });
      explorerBroadcastChannel?.postMessage({
        action: CHANNEL_ACTIONS.EXPLORER_ADD_NODE,
        payload: { parentId },
      });
    } else if (operationType === ETreeActionTypes.Cut) {
      const oldNodeParentId = nodesToCopy[0]?.parentId;
      const targetParentId = treeControlState.selectedExplorerNode?.id;
      await explorerRef.current.onRefreshTreeNode({ id: oldNodeParentId });
      explorerBroadcastChannel?.postMessage({
        action: CHANNEL_ACTIONS.EXPLORER_ADD_NODE,
        payload: { parentId: oldNodeParentId },
      });
      if (oldNodeParentId != targetParentId) {
        await explorerRef.current.onRefreshTreeNode({ id: targetParentId });
        explorerBroadcastChannel?.postMessage({
          action: CHANNEL_ACTIONS.EXPLORER_ADD_NODE,
          payload: { parentId: targetParentId },
        });
      }
    }
    setNodesToCopy([]);
  };

  const handleOnNodesPaste = useCallback(async () => {
    pasteNodesHandler(
      operationType,
      nodesToCopy,
      treeControlState.selectedExplorerNode,
      nodesPastePostProcessor,
      false,
      false,
    );
  }, [
    treeControlState.selectedExplorerNode,
    operationType,
    nodesToCopy,
    nodesPastePostProcessor,
  ]);

  const selectAllNodesBetweenTwoNodes = (node1: TreeNodeDTO, node2: TreeNodeDTO) => {
    const selectableElements =
      Array.from(document.querySelectorAll<HTMLElement>('.selectable-item')) || [];
    const { viewNodes } = treeControlState;

    const index1 = selectableElements.findIndex((item) => {
      const nodeId = parseInt(item.dataset.id || '');
      return nodeId === node1.id;
    });

    const index2 = selectableElements.findIndex((item) => {
      const nodeId = parseInt(item.dataset.id || '');
      return nodeId === node2.id;
    });
    const start = Math.min(index1, index2);
    const end = Math.max(index1, index2);
    const treeNodeIds = selectableElements
      .slice(start, end + 1)
      .map((el) => parseInt(el.dataset.id));
    setTreeControlState({
      ...treeControlState,
      selectedNodes: viewNodes.filter((node) => treeNodeIds.includes(node.id)),
    });
  };

  const onClickHandler = (node) => {
    if (
      isControlKeyPressed &&
      !treeControlState.selectedNodes.includes(treeControlState.selectedExplorerNode)
    ) {
      if (treeControlState.selectedNodes.includes(node)) {
        setTreeControlState((prev) => ({
          ...prev,
          selectedNodes: prev.selectedNodes.filter((_node) => _node !== node),
          isContextBackground: false,
        }));
      } else {
        setTreeControlState({
          ...treeControlState,
          selectedNodes: [...treeControlState.selectedNodes, node],
          isContextBackground: false,
        });
      }
    } else if (
      isShiftKeyPressed &&
      !treeControlState.selectedNodes.includes(treeControlState.selectedExplorerNode) &&
      treeControlState.selectedNodes.length > 0 &&
      node
    ) {
      selectAllNodesBetweenTwoNodes(treeControlState.selectedNodes?.[0], node);
    } else {
      setTreeControlState({
        ...treeControlState,
        selectedNodes: [node],
        isContextBackground: false,
      });
    }
  };

  const getClickHandler = (link, node, id, expanded, inputNodeName, eventDetail) => {
    const normalizedDetail = eventDetail % 2 === 0 ? 2 : 1;
    if (normalizedDetail === 1) {
      onClickHandler(node);
    } else if (normalizedDetail === 2) {
      DoubleClickHandler(link, node, id, expanded);
    }
  };

  const DoubleClickHandler = useCallback(
    (link, node, id, expanded) => {
      if (explorerRef?.current?.OnDoubleClick && !link) {
        explorerRef?.current?.OnDoubleClick(node);
      } else if (link !== null && link !== '#') {
        const nodeId =
          node?.type === ETreeNodeTypes.Protein || node?.type === ETreeNodeTypes.Seed
            ? node?.id
            : node?.extra?.id;
        node.extra.notSeen = false;
        openNode(link, link, nodeId, openedWindows, setOpenedWindows);
      }
    },
    [explorerRef?.current?.OnDoubleClick],
  );

  const onExplorerNodeClick = (node) => {
    if (status !== ESearchBarStatus.Empty) {
      clearSearch();
    }
    setIsSidePanelOpen(node.type !== ETreeNodeTypes.QuickAccess);
    navigate(`/project/${node.id}`, { replace: true });
  };
  const openImageNowModal = useCallback(() => {
    const selectedNodes = treeControlState?.selectedNodes;
    const expIds: number[] = [];
    selectedNodes.map(async (node) => {
      const selectedNodeExtra = node?.extra;
      expIds.push(selectedNodeExtra?.id);
    });
    setModalDetails({
      ...modalDetails,
      showModal: true,
      showButtons: false,
      body: (
        <ImageNow
          expIds={expIds}
          isOpenInPopup={true}
          onClose={() => setModalDetails({ ...modalDetails, showModal: false })}
        />
      ),
      heading: 'Image Now',
    });
  }, [treeControlState?.selectedNodes]);

  return (
    <TreeContext.Provider
      value={{
        copyNodeId,
        setCopyNodeId,
        operationType,
        setOperationType,
        copyNodeIdParent,
        setCopyNodeIdParent,
        copyNodeType,
        setCopyNodeType,
        copyNodeParentId,
        setCopyNodeParentId,
        copyNodeName,
        setCopyNodeName,
        sameNodeCopyId,
        setSameNodeCopyId,
        currentOperation,
        setCurrentOperation,
        showCommandPanel,
        setShowCommandPanel,
        viewType,
        setViewType,
        groupBy,
        setGroupBy,
        sortBy,
        setSortBy,
        focusedArea,
        setFocusedArea,
      }}
    >
      <RMModal
        id={`projectdashboard-modal-${modalDetails.heading}`}
        showModal={modalDetails.showModal}
        isCancelOnly={modalDetails.isCancelOnly}
        onOk={modalDetails.onOk}
        body={modalDetails.body}
        heading={modalDetails.heading}
        setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
        dialogClassName={modalDetails.dialogClassName}
        showButtons={modalDetails.showButtons}
      />
      <LoadingModal showModal={isLoading} text={currentOperation} />

      <MainHeader
        OpenClickHeader={OpenClickHeaderHandler}
        changeActiveDropDown={changeActiveDropDown}
        activeDropDown={activeDropDown}
        commonTreeNodes={commonTreeNodes}
        gSelectedNode={gSelectedNode}
        setCommonTreeNodes={setCommonTreenodes}
        setViewType={setViewType}
        selectedNodes={treeControlState.selectedNodes}
        selectedParentNode={treeControlState.selectedExplorerNode}
        newFolderType={getNewFolderName}
      />

      <div
        id="projectdashboard-container"
        style={{ height: '89.5%', width: '100%' }}
        onClick={changeActiveDropDownHandler}
      >
        <DragContextProvider>
          <div id="projectdashboard-root" style={styles.root}>
            <div id="projectdashboard-explorer-panel" style={styles.explorer}>
              <Explorer
                ref={explorerRef}
                dataSupplier={TreeDataSupplier}
                setCommonTreeNodes={setCommonTreenodes}
                commonTreeNodes={commonTreeNodes}
                setTreeControlState={setTreeControlState}
                treeControlState={treeControlState}
                setgSelectedNode={setgSelectedNode}
                showQuickAccessNode={!isRMLiteUser}
                showRecycleBinNode={!isRMLiteUser}
                treeNodeIdToLoadTree={parseInt(treeNodeId)}
                onNodeClickSelectPostAction={onExplorerNodeClick}
                selectAllNodes={selectAllNodes}
              />
            </div>
            {treeControlState?.selectedExplorerNode?.type !==
              ETreeNodeTypes.RecycleBin && (
              <div id="projectdashboard-right-panel" style={styles.rightPanel}>
                <div id="projectdashboard-action-header" style={styles.Actionheader}>
                  <TreeControlHeader
                    isProteinControl={false}
                    isScreenControl={false}
                    createNewNode={explorerRef?.current?.newNode}
                    treenodes={treeControlState.viewNodes}
                    selectedNodes={treeControlState.selectedNodes}
                    crumbs={treeControlState.breadcrumbs}
                    OnBreadCrumbClickSelect={explorerRef?.current?.onClickNodeChildren}
                    newFolderType={getNewFolderName}
                    refreshTreeNodeAfterRename={
                      explorerRef?.current?.onRefreshTreeNodeAfterRename
                    }
                    onRefreshTreeNodeAfterForceUnlock={
                      explorerRef?.current?.onRefreshTreeNodeAfterForceUnlock
                    }
                    nodeOpenHandler={getClickHandler}
                    cutNode={cutNode}
                    copyNode={copyNode}
                    pasteNode={handleOnNodesPaste}
                    deleteNode={handleOnNodesDelete}
                    printBarcode={printBarcode}
                    setViewType={setViewType}
                    treeControlState={treeControlState}
                    setTreeControlState={setTreeControlState}
                    nodesToCopy={nodesToCopy}
                    openImageNowModal={openImageNowModal}
                    setShowProteinVariantModal={setShowProteinVariantModal}
                    treeControlFlags={treeControlFlags}
                    focusedArea={focusedArea}
                    refreshSelectedExplorerNode={refreshSelectedExplorerNode}
                  />
                </div>
                <div id="projectdashboard-content-root" style={styles.contentRoot}>
                  <div
                    id="projectdashboard-content-container"
                    ref={nodesParentContainerRef}
                    style={{ ...styles.contentContainer, ...contentStyle }}
                  >
                    {showSearchStatus ? (
                      <ExplorerSearchStatus />
                    ) : (
                      <DragSelectionBox
                        onSelectionChange={onDragSelectionSelect}
                        isShiftKeyPressed={isShiftKeyPressed}
                        isDragSelect={isDragSelect}
                        setIsDragSelect={setIsDragSelect}
                      >
                        <TileView
                          crumbs={treeControlState.breadcrumbs}
                          viewNodes={treeControlState.viewNodes}
                          createNewNode={() => {}}
                          nodes={treeControlState.treenodes}
                          nodeClickHandler={getClickHandler}
                          onClickNodeChildren={explorerRef?.current?.onClickNodeChildren}
                          onDoubleClick={explorerRef?.current?.OnDoubleClick}
                          treeControlState={treeControlState}
                          setTreeControlState={setTreeControlState}
                          refreshNode={() => {}}
                          refreshTreeNodeAfterRename={() => {}}
                        />
                      </DragSelectionBox>
                    )}
                  </div>
                  <div
                    id="projectdashboard-side-panel"
                    style={{ ...styles.sidePanel, ...sidePanelStyle }}
                  >
                    <ProjectSidePanel
                      basePanelNode={
                        treeControlState.selectedNodes[
                          treeControlState.selectedNodes?.length - 1
                        ]
                      }
                      selectedNodes={treeControlState.selectedNodes}
                      createNewNode={explorerRef?.current?.newNode}
                      changeExperimentAndPlateState={
                        explorerRef?.current?.onRefreshTreeNodeAfterPlateStateChange
                      }
                      changePlateBarcode={
                        explorerRef?.current?.onRefreshTreeNodeAfterPlateBarcodeChange
                      }
                      setTreeControlState={setTreeControlState}
                      onRefreshTreeNodeAfterProteinVariantChange={
                        explorerRef?.current?.onRefreshTreeNodeAfterProteinVariantChange
                      }
                      openImageNowModal={openImageNowModal}
                      showProteinVariantModal={showProteinVariantModal}
                      setShowProteinVariantModal={setShowProteinVariantModal}
                      selectedExplorerNode={treeControlState.selectedExplorerNode}
                      isSearchResultActive={status !== ESearchBarStatus.Empty}
                    />
                    {treeControlState.selectedExplorerNode?.type !==
                      ETreeNodeTypes.QuickAccess && (
                      <div
                        id="projectdashboard-collapse-container"
                        style={styles.collapseContainer}
                      >
                        <div
                          id="projectdashboard-collapse-button"
                          onClick={() => setIsSidePanelOpen((prv) => !prv)}
                          style={styles.collapseButton}
                        >
                          <RMSvgIcon
                            id="projectdashboard-svg-chevron-arrowdown-icon"
                            fill={'black'}
                            name="ArrowDown"
                            style={{ rotate: isSidePanelOpen ? '-90deg' : '90deg' }}
                            height={18}
                            width={18}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {treeControlState?.selectedExplorerNode?.type ===
              ETreeNodeTypes.RecycleBin && (
              <div id="projectdashboard-recycle-bin" className="w-full h-[92%]">
                <RecycleBin onRefreshTreeNode={explorerRef.current?.onRefreshTreeNode} />
              </div>
            )}
          </div>
        </DragContextProvider>
      </div>
    </TreeContext.Provider>
  );
};

const styles: IStyle = {
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  explorer: {
    width: '22%',
    flexDirection: 'row',
    height: '100%',
  },
  rightPanel: {
    display: 'flex',
    width: '78%',
    flexDirection: 'column',
    height: '100%',
  },
  contentRoot: {
    display: 'flex',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  contentContainer: {
    border: 'solid 1px 1px 0 0',
    transition: 'width 1s',
    height: '100%',
    overflowX: 'hidden',
  },
  width100: {
    width: '100%',
  },
  mainContainershrink: {
    width: '63.5%',
  },
  sidePanel: {
    position: 'absolute',
    width: '28.5%',
    height: '100%',
    marginTop: '0',
    right: 0,
    transition: 'transform 1s',
    borderLeft: '1px #ccc solid',
    backgroundColor: 'white',
  },
  sidePanelClose: {
    transform: 'translate(100%, 0)',
  },
  width0: {
    width: 0,
  },
  Actionheader: {
    width: '101%',
    flexDirection: 'row',
    margin: '0% 0% 0.2% 0%',
    padding: '0.5% 0% 0.5% 0%',
    boxShadow: '0 4px 2px -2px #ccc',
    marginLeft: '0.3%',
  },
  collapseButton: {
    width: '2.125rem',
    boxShadow: '#ccc 0px 3px 2px -2px',
    backgroundColor: 'rgb(222 222 222',
    display: 'flex',
    height: '2rem',
    textTransform: 'uppercase',
    minHeight: '2rem',
    maxHeight: '2rem',
    fontSize: '1rem',
    borderRadius: '0.375rem',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
  },
  collapseContainer: {
    position: 'relative',
    bottom: '21%',
    right: '6.5%',
  },
};

const ProjectDashboard = (props) => {
  const isRMLiteUser = useRMLite();
  return (
    <SearchBarProvider key={isRMLiteUser ? 'rm-lite' : 'rm'}>
      <ProjectDashboardContent {...props} />
    </SearchBarProvider>
  );
};

export default memo(ProjectDashboard);
